import { ADMIN_PAGE_SIZE } from "./adminConstants";

export function buildAdminQuery({ q, cursor, limit = ADMIN_PAGE_SIZE, extra = {} } = {}) {
  const params = new URLSearchParams();
  if (q?.trim()) params.set("q", q.trim());
  if (cursor) params.set("cursor", cursor);
  params.set("limit", String(limit));
  Object.entries(extra).forEach(([key, val]) => {
    if (val != null && val !== "") params.set(key, String(val));
  });
  const s = params.toString();
  return s ? `?${s}` : "";
}
